import React from 'react';
import { ChevronDown } from 'lucide-react';

const LeagueHeader = ({ leagueName, leagueLogo, matchCount, isCollapsed }) => (
  // 2026-08-14: removed `backdrop-blur-sm` — costly on mobile PWA (browser
  // must re-blur bg every scroll frame). Using opaque background instead —
  // visually near identical but eliminates the biggest scroll-jank source.
  <div className="sticky top-0 z-10 bg-[#1A1A1A] px-3 py-2 border-b border-white/10 flex items-center gap-2">
    {leagueLogo && (
      <img
        src={leagueLogo}
        alt=""
        width="16"
        height="16"
        loading="lazy"
        decoding="async"
        className="w-4 h-4 rounded"
      />
    )}
    <span className="text-[10px] font-black uppercase tracking-widest text-[#F5A623] flex-1">{leagueName}</span>
    <span className="text-[10px] text-gray-600">{matchCount}</span>
    <ChevronDown
      className={`w-3.5 h-3.5 text-gray-500 transition-transform ${isCollapsed ? '-rotate-90' : 'rotate-0'}`}
    />
  </div>
);

export default React.memo(LeagueHeader);
